import { JWTAuth } from "../../../../lib/js-apiclient"
import { AdvancedApiClient } from "../../../../lib/js-apiclient/src/AdvancedApiClient";

export class FarfetchBrandMapApiClient extends AdvancedApiClient {

    static entityType = "FarfetchBrandMap"

    constructor(token, brandId, id) {
        super();

        this.setEntityType(FarfetchBrandMapApiClient.entityType)

        if(id !== undefined && id !== null) {
            this.setRoute("/api/v1/brand/{bid}/farfetch-map/{id}")
                .setRouteParam("bid", brandId)
                .setRouteParam("id", id);
        } else {
            this.setRoute("/api/v1/brand/{bid}/farfetch-map")
                .setRouteParam("bid", brandId);
        }
        
        if(token !== undefined && token !== null) {
            this.appendAuthSchema(new JWTAuth(token))
        }
    }

}